import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11f98836"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-list" }
const _hoisted_2 = { class: "columns columns--mobile" }
const _hoisted_3 = { class: "filter-items filter-items--kitchens first-column" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-list-close__icon" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-list-close__text" }, " Закрыть ", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-list-rollup__icon" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-list-rollup__text" }, " Свернуть ", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Item = _resolveComponent("Item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'columns',
        'columns--desktop',
        {
          'columns--block':
            !_ctx.filteredFilters.geographic.length || !_ctx.filteredFilters.notGeographic.length,
        }
      ])
    }, [
      (_ctx.filteredFilters.notGeographic.length)
        ? (_openBlock(), _createElementBlock("ul", {
            key: 0,
            class: _normalizeClass(["filter-items filter-items--kitchens first-column", { 'first-columns--full-size': !_ctx.filteredFilters.geographic.length }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredFilters.notGeographic, (filter) => {
              return (_openBlock(), _createBlock(_component_Item, {
                key: filter.id,
                item: filter,
                "is-selected": _ctx.isSelectedItem(filter),
                onClick: ($event: any) => (_ctx.$emit('select', filter.id))
              }, null, 8, ["item", "is-selected", "onClick"]))
            }), 128))
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.filteredFilters.geographic.length)
        ? (_openBlock(), _createElementBlock("ul", {
            key: 1,
            class: _normalizeClass(["filter-items filter-items--kitchens other-columns", { 'other-columns--full-size': !_ctx.filteredFilters.notGeographic.length }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredFilters.geographic, (filter) => {
              return (_openBlock(), _createBlock(_component_Item, {
                key: filter.id,
                item: filter,
                "is-selected": _ctx.isSelectedItem(filter),
                onClick: ($event: any) => (_ctx.$emit('select', filter.id))
              }, null, 8, ["item", "is-selected", "onClick"]))
            }), 128))
          ], 2))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mobileFilteredFilters, (filter, index) => {
          return (_openBlock(), _createBlock(_component_Item, {
            key: filter.id,
            item: filter,
            class: _normalizeClass({
            'filter-item--lst-column-frst-lst-item':
              (_ctx.isEven(_ctx.mobileFilteredFilters.length)
                ? index === _ctx.mobileFilteredFilters.length / 2
                : index === Math.ceil(_ctx.mobileFilteredFilters.length / 2) - 1)
              || (index === _ctx.mobileFilteredFilters.length - 1)
          }),
            "is-selected": _ctx.isSelectedItem(filter),
            onClick: ($event: any) => (_ctx.$emit('select', filter.id))
          }, null, 8, ["item", "class", "is-selected", "onClick"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", {
      class: "filter-list-close",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }, _hoisted_6),
    _createElementVNode("div", {
      class: "filter-list-rollup",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
    }, _hoisted_9)
  ]))
}